import { Result, Typography, Image } from 'antd';
import { StyledModal } from 'common/components';

import WalmartLogo from 'assets/retailer/walmart.png';
import useGlobalModal from 'hooks/useGlobalModal';

const { Paragraph, Text } = Typography;

const PostToGdsnSuggestionModal = ({
  visible,
  onCancel,
  targetType = ['walmart', 'krogger'][0],
}) => {
  const { MODAL_NAMES, openModal } = useGlobalModal();

  const handleOpenGDSNPublish = () => {
    onCancel();
    openModal(
      targetType === 'walmart'
        ? MODAL_NAMES.PUBLICATION_WALMART_SETUP_MODAL
        : MODAL_NAMES.PUBLICATION_KROGGER_SETUP_MODAL
    );
  };

  return (
    <StyledModal
      title='Publish product to GDSN suggestion'
      visible={visible}
      footer={null}
      onCancel={onCancel}
      maskClosable={false}
      width={780}
    >
      <Result
        status='success'
        title={
          <Paragraph style={{ marginBottom: 0 }}>
            <Text>You have successfully posted the selected product(s) to</Text>
            <Image
              src={WalmartLogo}
              width={100}
              preview={false}
              style={{ marginTop: -2 }}
            />
          </Paragraph>
        }
        subTitle={
          <Paragraph style={{ marginBottom: 0, marginTop: 8 }}>
            <Text>
              Selected product(s) may need to be published to Walmart via GDSN.
              If you are using RIVIR as your GDSN Data Pool and would like to
              publish the product(s) to Walmart via GDSN,{' '}
              <a onClick={handleOpenGDSNPublish}>click here</a>
              .
              <br />
              <br />
            </Text>
            <Text style={{ marginTop: 16 }}>
              If you are not using RIVIR as your GDSN Data Pool and would like
              to speak with someone about further leveraging RIVIR for GDSN
              publications, please contact the support team at{' '}
              <a href='mailto:gorivirsupport@spins.com'>
                gorivirsupport@spins.com
              </a>
              .
            </Text>
          </Paragraph>
        }
      />
    </StyledModal>
  );
};

export default PostToGdsnSuggestionModal;
